import { render, staticRenderFns } from "./EditChannelInfo.vue?vue&type=template&id=9c887a56&scoped=true&"
import script from "./EditChannelInfo.vue?vue&type=script&lang=js&"
export * from "./EditChannelInfo.vue?vue&type=script&lang=js&"
import style0 from "./EditChannelInfo.vue?vue&type=style&index=0&id=9c887a56&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c887a56",
  null
  
)

export default component.exports